import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { handleStatsMessaging } from "../../lib";
import styles from "./StatsMessage.module.scss";
import { last5StatType } from "../../constants";

const StatsMessage = ({
  marketType,
  selectionName,
  selectionType,
  toggleStatsPanel,
  type,
  statsLength,
  statsTeamType,
}) => {
  const { filters } = useSelector((state) => state.filter);
  const { activeView } = useSelector((state) => state.view);

  const statsFilter =
    activeView !== "betShuffle" ? filters.stats : last5StatType;

  return toggleStatsPanel ? (
    <div
      className={styles.statsMessage}
      data-testid={`stats-message-${marketType}`}
    >
      The previous form for{" "}
      {handleStatsMessaging({
        type,
        selectionName,
        selectionType,
        marketType,
        statsFilter,
        statsLength,
        statsTeamType,
      })}
    </div>
  ) : null;
};

StatsMessage.propTypes = {
  marketType: PropTypes.string,
  toggleStatsPanel: PropTypes.bool,
  selectionName: PropTypes.string,
  selectionType: PropTypes.string,
  type: PropTypes.string,
  statsLength: PropTypes.number,
  statsTeamType: PropTypes.string,
};

export default StatsMessage;
